import { useCallback, useContext } from "react";
import NoticesContext from "@jnctn-app/contexts/NoticesContext";
import StandardButton from "@jnctn/design-system/Button/StandardButton.component";
import Notice from "./Notice";
import useDismissableAutohider from "@jnctn/hooks/useDismissableAutohider";
import useOnline from "@jnctn/hooks/useOnline";
import { ReactComponent as DownloadIcon } from "@jnctn/icons/download.svg";
import { ReactComponent as CloseIcon } from "@jnctn/icons/close.svg";
import Text from "@jnctn/design-system/Text/Text.component";
import Button from "@jnctn/design-system/Button/Button.component";

const UPDATE_DISMISS_DELAY = 30 * 1000;

export default function UpdateNotice() {
  const { update, setUpdate, registration } = useContext(NoticesContext);
  const online = useOnline();
  const [hideUpdate] = useDismissableAutohider(
    update,
    () => setUpdate(false),
    UPDATE_DISMISS_DELAY,
    50
  );
  const onUpdateNow = useCallback(() => {
    if (!registration) {
      hideUpdate();
      return;
    }
    const registrationWaiting = registration.waiting;
    if (registrationWaiting) {
      registrationWaiting.postMessage({ type: "SKIP_WAITING" });
      registrationWaiting.addEventListener("statechange", (e) => {
        if (((e.target as any)?.state as ServiceWorkerState) === "activated") {
          window.location.reload();
        }
      });
    }
    hideUpdate();
  }, [registration, hideUpdate]);

  if (update) {
    return (
      <Notice
        type="attention"
        text="Update"
        actions={[
          <StandardButton
            label="download"
            onClick={onUpdateNow}
            disabled={!registration || !online}
            size="small"
            type="transparent"
          />,
          <Button
            label="Update later"
            onClick={hideUpdate}
            labelHidden={true}
            icon={
              <Text color="white" size="body1">
                <CloseIcon className="w-8 h-8" />
              </Text>
            }
          />,
        ]}
        icon={
          <Text color="white-secondary" size="body1">
            <DownloadIcon className="w-10 h-10" />
          </Text>
        }
      />
    );
  }

  return null;
}
